const knownAbbreviations = [
  'approx.',
  'appt.',
  'apt.',
  'A.S.A.P.',
  'B.Y.O.B.',
  'c/o',
  'dept.',
  'D.I.Y.',
  'est.',
  'E.T.A.',
  'Inc.',
  'min.',
  'misc.',
  'Mr.',
  'Mrs.',
  'no.',
  'R.S.V.P.',
  'tel.',
  'temp.',
  'vet.',
  'vs.'
]

exports.knownAbbreviations = knownAbbreviations
